import styled from 'styled-components';

export const CheckboxContainer = styled.div``;

export const Disabled = `
  cursor: not-allowed;
  opacity: 0.3 !important;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: ${props => props.theme.color.primary.v200};
  stroke-width: 3px;
`;

export const CircleIconWrapper = styled.svg`
  fill: ${props => props.theme.color.primary.v200};
  flex-basis: 100%;
  stroke: ${props => props.theme.color.primary.v200};
  stroke-width: 5px;
`;

export const CircleIcon = styled.circle.attrs({ cx: '5', cy: '5', r: '3' })``;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const checkboxSize = 24;

export const StyledCheckbox = styled.div`
  background-color: white;
  display: flex;
  width: ${checkboxSize}px;
  height: ${checkboxSize}px;
  border-radius: ${props => (props.round ? 15 : 3)}px;
  cursor: pointer;
  transition: all 150ms;
  border: 1px solid
    ${props =>
      !props.checked
        ? props.theme.color.neutral.v300
        : props.theme.color.primary.v200};

  ${Icon} {
    flex-basis: 100%;
    transform: scale(0.7);
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }

  ${CircleIcon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }

  ${props => props.disabled && Disabled}

  &:hover {
    border: 1px solid ${props => props.theme.color.primary.v200};
  }
`;

export const CheckboxText = styled.span`
  color: ${props => props.theme.color.primary.v600};
  line-height: 1.5;
  margin-left: 10px;
  font-size: 16px;
  cursor: pointer;

  ${props => props.disabled && Disabled}
`;

export const CheckboxLabel = styled.label`
  cursor: pointer;
  display: flex;
`;
